import { Injectable } from '@angular/core';
import { CanMatch, Route, Router, UrlSegment, UrlTree } from '@angular/router';

/* the admin panel is restricted to the two highest roles - the navigation item is
   hidden for everyone else, this guard covers a direct hit on /admin-panel */
export const ADMIN_PANEL_ROLES: string[] = ['ServerAdmin', 'SuperAdmin'];

export function hasAdminPanelAccess(): boolean
{
    try
    {
        const user = JSON.parse(localStorage.getItem('user'));
        return !!user && ADMIN_PANEL_ROLES.indexOf(user.role) > -1;
    }
    catch (e)
    {
        return false;
    }
}

@Injectable({
    providedIn: 'root'
})
export class AdminRoleGuard implements CanMatch
{
    constructor(private _router: Router)
    {
    }

    canMatch(route: Route, segments: UrlSegment[]): boolean | UrlTree
    {
        if ( hasAdminPanelAccess() )
        {
            return true;
        }

        return this._router.parseUrl('/retail-outlets');
    }
}
